<template>
  <div>
    <strong :style="color" class="score">{{item['likelihoodAttack']}}</strong>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ImpactScoreTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed:{
    color(){
        const severity = this.item['likelihoodAttack'];
        if (severity === 'Critical'){
            return {"color":'#E0255E','background-color':'#E0255030'};
        }
        else if (severity === 'High'){
            return {"color":'#FF7F00','background-color':'#FF7F0030'};
        }
        else if (severity === 'Medium'){
            return {"color":'#FF7F00','background-color':'#FF7F0030'};
        }
        else{
            return {"color":'#2BAF69','background-color':'#2BAF6030'};
        }
    }
  }
};
</script>

<style>

.score{
  font-family: "SF Pro Display",sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
}

</style>
